import { render, staticRenderFns } from "./AccountTip.vue?vue&type=template&id=75960d54&scoped=true&"
import script from "./AccountTip.vue?vue&type=script&lang=js&"
export * from "./AccountTip.vue?vue&type=script&lang=js&"
import style0 from "./AccountTip.vue?vue&type=style&index=0&id=75960d54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75960d54",
  null
  
)

export default component.exports